import {effect, inject, Injectable} from "@angular/core";
import {KEYCLOAK_EVENT_SIGNAL, KeycloakEventType} from "keycloak-angular";
import Keycloak, {KeycloakTokenParsed} from "keycloak-js";
import {CookieService} from "ngx-cookie-service";


@Injectable(
  {
    providedIn: "root",
  }
)
export class AuthService {

  private readonly keycloak = inject(Keycloak);
  private readonly cookieService = inject(CookieService);

  constructor() {
    const keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

    effect(() => {
      const keycloakEvent = keycloakSignal();

      if (keycloakEvent.type === KeycloakEventType.Ready) {
        this.cookieService.set("token", this.keycloak.token ?? "");
      } // TODO: not in this service!
      else if (keycloakEvent.type === KeycloakEventType.AuthRefreshSuccess) {
        this.cookieService.set("token", this.keycloak.token ?? "");
      }
    });

  }

  get token(): string | undefined {
    return this.keycloak.token;
  }

  get parsedToken(): KeycloakTokenParsed | undefined {
    return this.keycloak.tokenParsed;
  }

  get userRoles(): string[] {
    return this.keycloak.tokenParsed?.realm_access?.roles
      .filter(role => role === "admin" ||role === "installer" || role === "owner" || role === "guest") ?? [];
  }

  logout() {
    this.keycloak.logout();
  }


}
